<script>
 import { onMount } from "svelte";
 import { Route, router } from "tinro";
 router.mode.history();

 import OpenGraph from "./components/OpenGraph.svelte";
 import Header from "./components/Header.svelte";
 import EpisodeRoute from "./components/EpisodeRoute.svelte";
 import Main from "./components/Main.svelte";
 import Footer from "./components/Footer.svelte";

 import { current_episode, episodes, episode_desc } from "./stores/store.js";

 let promise;

 // this is a temporary fix, since frontend and backend development happen on different ports
 // the production version will use the same url and won't be needed
 /* const getCurrentEpisode = (episodes, current_index) => {
  *     const episode = episodes[current_index];
  *     if (episode && episode.image)
  *         episode.image = backend_url + episode.image;
  *     if (episode && episode.episode)
  *         episode.episode = backend_url + episode.episode;

  *     return episode;
  * }; */

 $: episode = ($episodes &&$episodes.length > 0) ? $episodes[$current_episode] : null;

 async function getEpisodes() {
     const res = await fetch("/api/episodes");
     const json = await res.json();

     if (res.ok) {
         $episodes = json;
         return json;
     } else {
         throw new Error(text);
     }
 }

 onMount(() => {
     promise = getEpisodes();
 });
</script>

{#if episode}
    <OpenGraph {episode} />
{/if}

<Header />

<main class="container mx-auto mt-2">
        {#if episode}
            {#key $router.path}
                <Route path="/*" let:meta>
                    <EpisodeRoute url={meta.url} />
                </Route>
            {/key}
            <Main {episode} episode_desc={$episode_desc} />
        {:else}
            <p>loading...</p>
        {/if}

</main>

<Footer />


